// #region STORAGE KEYS
export const STORE_ITEM_SESSION_ID = 'sessionID';
export const STORE_ITEM_REFRESH_TOKEN = 'refreshToken';
export const STORE_ITEM_ANALYTICS_ID = 'analyticsId';
export const STORE_ITEM_ANALYTICS_LOCATION = 'analytics.location';
export const STORE_ITEM_LOGIN_PROVIDER = 'loginProvider';
export const STORE_ITEM_NONCE = 'nonce';
export const STORE_ITEM_CURRENT_USER = 'current_user';

export const COOKIE_NONCE = 'nonce';

export const STORAGE_ITEM_XSOLLA_SPECIAL_OFFER_UPSELL_OFFER =
  'xsolla.specialOffer.upsellOffer';
export const STORAGE_ITEM_XSOLLA_INTERSTITIAL_OFFER_UPSELL_OFFER =
  'xsolla.interstitialOffer.upsellOffer';
export const STORAGE_ITEM_DEBUG_CONFIG = 'featureFlags.debug';
export const STORAGE_ITEM_XSOLLA_SPECIAL_OFFER = 'xsolla.specialOffer';
export const STORAGE_ITEM_XSOLLA_INTERSTITIAL_OFFER =
  'xsolla.interstitialOffer';
export const STORAGE_ITEM_STORE_OFFER_VIEWS = 'store.offerViews';
export const STORAGE_ITEM_STORE_CACHED_VIRTUALIZER = 'store.cachedVirtualizer';
export const STORAGE_ITEM_INTERSTITIAL_HISTORY = 'interstitial.history';
export const STORAGE_ITEM_PURCHASING_STEPUP_OFFER = 'store.stepupOffer';

export const STORAGE_ITEM_ANALYTICS_BANNER_DESTINATION =
  'home.banner.destination';

export const STORAGE_ITEM_SUBSCRIPTION_UPDATE = 'xsolla.subscription.update';
export const STORAGE_ITEM_SUBSCRIPTION_SUBSCRIBE =
  'xsolla.subscription.subscribe';
export const STORAGE_ITEM_SUPERSTAR_TUTORIAL = 'superstar.tutorial';

export const STORAGE_ITEM_TWITCH_CONNECT_PREVIOUS_PATH =
  'twitch.connect.previousPath';

export const STORAGE_ITEM_LOCAL_CONFIG = 'localConfig';
// #endregion STORAGE KEYS

// #region DIALOG KEYS
export const DIALOG_ID_SPECIAL_OFFER_PREVIEW = 'special-offer-review-dialog';
export const DIALOG_ID_SPECIAL_REWARD_PREVIEW = 'special-reward-review-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER_TO_UPSELL =
  'interstitial-offer-to-upsell-dialog';
export const DIALOG_ID_SPECIAL_OFFER_TO_UPSELL =
  'special-offer-to-upsell-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER = 'interstitial-offer-dialog';
export const DIALOG_ID_INTERSTITIAL_OFFER_UPSELL =
  'interstitial-offer-upsell-dialog';
export const DIALOG_ID_INTERSTITIAL_SURVEY = 'interstitial-survey-dialog';
// #endregion

// #region REACT-QUERY KEYS
// Subscription query key
export const QUERY_KEY_SUBSCRIPTION = 'subscription';
export const QUERY_KEY_SUBSCRIPTION_USER = 'subscription-user';
export const QUERY_KEY_SUBSCRIPTION_INTERSTITIAL = 'subscription-interstitial';

// ClubStore query key
export const QUERY_KEY_ROSTER = 'clubstore-player-rosters';
export const QUERY_KEY_EXCLUSIVE_ITEMS = 'clubstore-exclusive-items';
export const QUERY_KEY_MISSION_ITEMS = 'clubstore-mission-items';
export const QUERY_KEY_MISSION_CLAIM_STATUS = 'clubstore-claim-all-status';
export const QUERY_KEY_MISSION_PROGRESS_STATUS =
  'clubstore-mission-progress-status';

// Store Revamp Offers key
export const QUERY_KEY_OFFER_V2 = 'offer-v2';
export const QUERY_KEY_OFFER_VIRTUALIZATION = 'offer-virtualization';
export const QUERY_KEY_USER_STOCKS_V2 = 'offer-stocks-v2';

// Interstitial query key
export const QUERY_KEY_INTERSTITIAL = 'interstitial';
// #endregion

// Global Search query key
export const QUERY_KEY_GLOBAL_SEARCH = 'global-search';

// User Info query key
export const QUERY_KEY_USER_INFO = 'user-info';
export const QUERY_KEY_USER_EXPERIMENTS = 'user-experiments';
export const QUERY_KEY_USER_FEATURE_CONFIGS = 'user-feature-configs';

// Currencies query key
export const QUERY_KEY_CURRENCIES = 'currencies';

// Config query key
export const QUERY_KEY_CONFIG = 'config';

export const QUERY_KEY_CALENDAR = 'calendar-events';

export const QUERY_KEY_PLAYER_PROFILE = 'player-profile';

// #region GLOBAL IDS
export const LEFT_SIDEBAR_ID = 'left-sidebar';
// #endregion
